import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

/**
 * Resets the scroll position to the top on every navigation. Without this the
 * SPA keeps the previous page's scroll offset, so a new page can open already
 * scrolled halfway down.
 *
 * Anchored navigations (URLs with a hash such as "#listino") are left untouched
 * so in-page jumps keep working; the browser handles those natively.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
